import { ActionLog } from "@pjs/a11y";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component("actionLog", react2angular(ActionLog, []));
